const ViewModeConstants = {
  OVERVIEW: 'OVERVIEW',
  WEATHER: 'WEATHER',
  ANALYSIS: 'ANALYSIS',
  PRESCRIPTION: 'PRESCRIPTION',
  PRESCRIPTION_ARCHIVE: 'PRESCRIPTION_ARCHIVE',
  MANAGE_CROPS: 'MANAGE_CROPS',
  MANAGE_WEATHER_STATION_FIELD_CONNECTIONS: 'MANAGE_WEATHER_STATION_FIELD_CONNECTIONS',
  FIELD_STATISTICS: 'FIELD_STATISTICS',
  EDIT_FIELD: 'EDIT_FIELD',
  ADD_EDIT_INNERBOUNDARIES: 'ADD_EDIT_INNERBOUNDARIES',
  EDIT_FIELD_BOUNDARIES: 'EDIT_FIELD_BOUNDARIES',
  SPLIT_FIELD: 'SPLIT_FIELD',
  MERGE_FIELDS: 'MERGE_FIELDS',
  BULK_PRESCRIPTION: 'BULK_PRESCRIPTION',
} as const;

export type ViewMode = (typeof ViewModeConstants)[keyof typeof ViewModeConstants];

export default ViewModeConstants;
